import React, { useState } from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';
import { SendANotification } from '../SendANotification/SendANotification';

interface DialogRejectEventProps {
  eventId: number; // event id to reject/decline
  onSuccess: () => void;  // Callback to refresh events list after rejection
  onCancel: () => void; // Callback to close the dialog
}

export const DialogRejectEvent: React.FC<DialogRejectEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleRejectEvent, logMessage, setLogMessage, updating } = useEvent();
  const [requestType, setRequestType] = useState('Select')

  const handleReject = async () => {
    const success = await handleRejectEvent(eventId, requestType);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  return (
    <SendANotification
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleReject}
      onSecondaryButtonClick={onCancel}
      requestType={requestType}
      setRequestType={setRequestType}
      logMessage={logMessage}
      setLogMessage={setLogMessage}
    />
  );
}; 